import { Container } from '@ui/wrapper'
import Image from '@ui/image'
import {
  SectionWrapper,
  StyledText,
  ImgWrapper,
  InfoCircle,
  InfoCircleText
} from './style'

const BSWPreisFuerWirtschaftsJournalismusArea = ({
  data,
  dataInfo,
  ...rest
}) => {
  const infoCircleExists = dataInfo?.headings?.length > 0

  return (
    <>
      {infoCircleExists && (
        <div style={{ position: 'relative' }}>
          <InfoCircle>
            <InfoCircleText
              dangerouslySetInnerHTML={{
                __html: dataInfo?.headings[0].content
              }}
            />
          </InfoCircle>
        </div>
      )}
      <SectionWrapper {...rest}>
        <Container>
          <StyledText>
            <div style={{ maxWidth: infoCircleExists ? '86%' : '100%' }}>
              {data?.images?.map((image, i) => (
                <ImgWrapper key={i}>
                  <Image
                    key={i}
                    src={image?.src.localFile.publicURL || image?.src}
                    alt={image?.src.alternativeText || 'Page Header'}
                  />
                </ImgWrapper>
              ))}
            </div>
          </StyledText>
        </Container>
      </SectionWrapper>
    </>
  )
}

export default BSWPreisFuerWirtschaftsJournalismusArea
